/**
 * Deutscher Textkatalog für das `auth`-Feature (Anmeldung, Registrierung,
 * Magic-Link-Verifizierung, Passwort zurücksetzen / festlegen). Die Schlüssel
 * sind 1:1 den `t('auth.*')`-Aufrufen in
 * `packages/@gamecodex/world-ui/src/features/auth/*` zugeordnet. Die Werte sind
 * die deutschen Übersetzungen der englischen Originaltexte.
 */
export const authDe = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Grymwyrd-Startseite',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Mit Google fortfahren',
  'auth.oauth.continueWithDiscord': 'Mit Discord fortfahren',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': 'Anmeldung läuft',
  'auth.verify.seoDescription': 'Dein Grymwyrd-Anmeldelink wird überprüft.',
  'auth.verify.errorMissingToken':
    'Diesem Anmeldelink fehlt sein Token. Fordere auf der Anmeldeseite einen neuen an.',
  'auth.verify.errorInvalidOrExpired':
    'Dieser Anmeldelink ist ungültig oder abgelaufen. Fordere auf der Anmeldeseite einen neuen an.',
  'auth.verify.confirming': 'Deine Anmeldung wird bestätigt…',
  'auth.verify.signedInHeading': 'Du bist angemeldet',
  'auth.verify.signedInAsPrefix': 'Angemeldet als',
  'auth.verify.signedInAsSuffix': '. Wir bringen dich zu deinem Refugium…',
  'auth.verify.takingYouToSanctum': 'Wir bringen dich zu deinem Refugium…',
  'auth.verify.goNow': 'Jetzt los',
  'auth.verify.problemHeading': 'Problem mit dem Anmeldelink',
  'auth.verify.backToSignIn': 'Zurück zur Anmeldung',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': 'Gib oben deine E-Mail-Adresse ein und fordere dann einen Link an.',
  'auth.login.seoTitle': 'Überschreite die Schwelle',
  'auth.login.seoDescription': 'Melde dich bei Grymwyrd an und kehre zu deiner Legende im ewigen Zwielicht zurück.',
  'auth.login.eyebrow': 'Kehre zurück, Wanderer',
  'auth.login.title': 'Überschreite die Schwelle',
  'auth.login.blurb': 'Sprich deinen Namen und das geheime Wort, um das ewige Zwielicht erneut zu betreten.',
  'auth.login.noPactYet': 'Noch keinen Pakt?',
  'auth.login.forgeYourLegend': 'Schmiede deine Legende',
  'auth.login.emailLabel': 'E-Mail',
  'auth.login.emailPlaceholder': 'du@grymwyrd.com',
  'auth.login.passwordLabel': 'Passwort',
  'auth.login.forgotPassword': 'Passwort vergessen?',
  'auth.login.submitBusy': 'Überschreite die Schwelle…',
  'auth.login.submit': 'Eintreten',
  'auth.login.dividerOr': 'oder',
  'auth.login.magicSentPrefix': 'Ein Anmeldelink ist unterwegs',
  'auth.login.magicSentTo': 'an',
  'auth.login.magicSentSuffix': '. Sieh in deinem Posteingang nach.',
  'auth.login.emailMeSignInLink': 'Schick mir einen Anmeldelink',
  'auth.login.mockAuthPrefix': 'Dev-Mock-Auth: Jede E-Mail funktioniert. Verwende',
  'auth.login.mockAuthOr': 'oder',
  'auth.login.mockAuthSuffix': 'für erweiterte Rollen.',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': 'Wähle den Namen, unter dem deine Legende erzählt wird.',
  'auth.register.errorEmailRequired': 'Für den Pakt ist eine E-Mail-Adresse erforderlich.',
  'auth.register.errorEmailInvalid': 'Diese E-Mail-Adresse sieht nicht richtig aus.',
  'auth.register.errorPasswordTooShort': 'Dein geheimes Wort muss mindestens 8 Zeichen lang sein.',
  'auth.register.errorMustBeAdult': 'Du musst mindestens 13 Jahre alt sein, um Grymwyrd beizutreten.',
  'auth.register.errorMustAcceptTerms': 'Du musst den Pakt (die Bedingungen) annehmen, um fortzufahren.',
  'auth.register.errorIncomplete': 'Einige Zeichen auf deinem Pakt sind unvollständig. Siehe unten.',
  'auth.register.seoTitle': 'Beginne deine Geschichte',
  'auth.register.seoDescription':
    'Erstelle ein Grymwyrd-Konto, erwecke einen Avatar und lass deine Geschichte zum Kanon werden.',
  'auth.register.eyebrow': 'Erkunde das Dorf Greywick',
  'auth.register.title': 'Beginne deine Geschichte',
  'auth.register.blurb': 'Du erwachst aus ätherischen Träumen und öffnest deine Augen…',
  'auth.register.alreadyBound': 'Schon an das Zwielicht gebunden?',
  'auth.register.loginToExisting': 'Bei deinem bestehenden Konto anmelden',
  'auth.register.displayNameLabel': 'Anzeigename',
  'auth.register.displayNamePlaceholder': 'Der Hohle Ritter',
  'auth.register.displayNameHint': 'Damit werden dein öffentlicher Avatar und deine Beiträge benannt.',
  'auth.register.emailLabel': 'E-Mail',
  'auth.register.emailPlaceholder': 'du@grymwyrd.com',
  'auth.register.passwordLabel': 'Passwort',
  'auth.register.passwordPlaceholder': 'Mindestens 8 Zeichen',
  'auth.register.agreementsLegend': 'Vereinbarungen',
  'auth.register.adultConfirmPrefix': 'Ich bestätige, dass ich',
  'auth.register.adultConfirmEmphasis': '13 Jahre alt oder älter',
  'auth.register.adultConfirmSuffix': 'bin.',
  'auth.register.acceptPrefix': 'Ich akzeptiere die',
  'auth.register.termsOfThePact': 'Bedingungen des Pakts',
  'auth.register.acceptSuffix': '.',
  'auth.register.submitBusy': 'Der Pakt wird besiegelt…',
  'auth.register.submit': 'Hervortreten',
  'auth.register.dividerOr': 'oder',
  'auth.register.mockAuthNote': 'Dev-Mock-Auth: Die Registrierung wird nur lokal gespeichert. Es wird keine E-Mail versendet.',
  'auth.register.lastUpdated': 'Zuletzt aktualisiert {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Gib die mit deinem Pakt verknüpfte E-Mail-Adresse ein.',
  'auth.reset.seoTitle': 'Passwort zurücksetzen',
  'auth.reset.seoDescription':
    'Passwort vergessen? Wir schicken dir einen Einmal-Link per E-Mail; klick darauf, um ein neues Passwort zu wählen.',
  'auth.reset.eyebrow': 'Das Wort verloren',
  'auth.reset.title': 'Passwort zurücksetzen',
  'auth.reset.blurb':
    'Flüstere deine E-Mail-Adresse, und ein Einmal-Link wird in die Dunkelheit gesandt. Folge ihm zurück, und du legst ein neues Passwort fest.',
  'auth.reset.rememberedAfterAll': 'Doch wieder eingefallen?',
  'auth.reset.loginToExisting': 'Bei deinem bestehenden Konto anmelden',
  'auth.reset.successMessage':
    'Falls für {email} ein Konto existiert, wurde ein Einmal-Link gesandt. Öffne ihn, um dich anzumelden und dein neues Passwort festzulegen — sieh in deinem Posteingang nach, und in der Spam-Gruft.',
  'auth.reset.sendToDifferentEmail': 'An eine andere E-Mail-Adresse senden',
  'auth.reset.emailLabel': 'E-Mail',
  'auth.reset.emailPlaceholder': 'du@grymwyrd.com',
  'auth.reset.submitBusy': 'Beschwörung…',
  'auth.reset.submit': 'Anmeldelink senden',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': 'Wähle ein Passwort mit mindestens 8 Zeichen.',
  'auth.setPassword.errorMismatch': 'Diese Passwörter stimmen nicht überein.',
  'auth.setPassword.seoTitle': 'Passwort festlegen',
  'auth.setPassword.seoDescription': 'Wähle ein neues Passwort für dein Grymwyrd-Konto.',
  'auth.setPassword.eyebrow': 'Besiegle den Pakt',
  'auth.setPassword.title': 'Neues Passwort festlegen',
  'auth.setPassword.blurb':
    'Du bist angemeldet. Wähle ein neues Passwort — beim nächsten Mal kannst du es zusätzlich zum Magic-Link verwenden.',
  'auth.setPassword.ratherNot': 'Lieber nicht?',
  'auth.setPassword.skipForNow': 'Vorerst überspringen',
  'auth.setPassword.successMessage': 'Dein Passwort ist festgelegt. Wir bringen dich zu deinem Refugium…',
  'auth.setPassword.newPasswordLabel': 'Neues Passwort',
  'auth.setPassword.newPasswordPlaceholder': 'Mindestens 8 Zeichen',
  'auth.setPassword.confirmPasswordLabel': 'Passwort bestätigen',
  'auth.setPassword.confirmPasswordPlaceholder': 'Gib es erneut ein',
  'auth.setPassword.submitBusy': 'Besiegelung…',
  'auth.setPassword.submit': 'Passwort speichern',
}
